// TODO: the class should be cut into some smaller ones (cutting by API purpose)
export default class PageComponentTracker {
  constructor() {
    this.createNewPageComponent();
  }

  // API shared by React context
  addField = ({ field, value }) => {
    if (value !== undefined) {
      this.pageComponent.fields[field] = value;
    }
  };

  // API used to manage the tracker
  createNewPageComponent = () => {
    this.pageComponent = { id: null, type: null, fields: {} };
  };

  configurePageComponent = ({ id, type }) => {
    this.pageComponent.id = id;
    this.pageComponent.type = type;
  };
}
